export const typeRepair = [
    { id: 1, name: 'เปิด' },
    { id: 2, name: 'รอวันนัดเข้าพื้นที่จากผู้เช่า' },
    { id: 5, name: 'รอจัดซื้อจัดจ้าง' },
    { id: 6, name: 'รอเบิกของ' },
    { id: 3, name: 'รอยืนยันการปิดงานโดยผู้เช่า' },
    { id: 4, name: 'ปิด' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeRepair.js